import axios from "axios";
import { apiBaseUrl, apiBaseUrlV1 } from "../utils/constant";

export const getDomainSuggestions = async (data) => {
    return await axios.get(`${apiBaseUrlV1}/suggest_domain?company_name=${data.company_name}`);
};
